// Environment-aware configuration
const status = import.meta.env.MODE || "development";

// API URL - supports environment variable override for Docker/production deployments
export const localRequest = import.meta.env.VITE_API_URL ||
  (status === "development"
    ? "http://localhost:9441/student/"
    : "https://app.hsmltuge.name.ng/student/");

// App Host URL
export const appHost = `${window.location.origin}/`;

// Staff Backend URL (for logos and assets)
export const staffBackend = status === "development"
  ? "http://localhost:9441/"
  : "https://app.hsmltuge.name.ng/";

// Upload Link
export const UploadLink = "https://doc.samtec.ng/index.php";
